import LetterContext from 'app/contexts/LetterContext'
import { useContext } from 'react'

const useLetter = () => useContext(LetterContext)

export default useLetter
